import { LucideIcon } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface EmptyStateProps {
  icon: LucideIcon;
  title: string;
  description?: string;
  action?: {
    label: string;
    onClick: () => void;
  };
}

export const EmptyState = ({ icon: Icon, title, description, action }: EmptyStateProps) => (
  <div className="flex flex-col items-center justify-center py-16 text-center">
    <div className="w-20 h-20 rounded-full bg-primary-50 flex items-center justify-center mb-4">
      <Icon className="h-10 w-10 text-primary-400" />
    </div>
    <h3 className="text-xl font-heading font-semibold text-gray-800 mb-2">{title}</h3>
    {description && <p className="text-gray-500 max-w-sm mb-6">{description}</p>}
    {action && (
      <Button onClick={action.onClick}>{action.label}</Button>
    )}
  </div>
);
